var _style, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMalinha(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 26 26",
    style: {
      enableBackground: "new 0 0 26 26"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#00404F;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M25.9,19.4l-1.5-7.4c-0.1-0.3-0.1-0.5-0.3-0.8c-0.2-0.9-0.7-1.8-1.4-2.5c-0.7-0.8-1.7-1.3-2.7-1.4h-1.1 c-0.3-1.4-0.8-2.7-1.5-4c-0.4-0.7-1-1.3-1.6-1.7c-0.7-0.5-1.5-0.7-2.4-0.8h0c-1.4-0.1-2.8,0.4-3.9,1.4C8.4,3.3,7.6,5,7.1,7.2H5.9 c-1,0-2,0.5-2.7,1.3C2.6,9.2,2.2,10,2,10.9c-0.2,0.3-0.3,0.6-0.4,1l-1.5,7.4C0,19.7,0,20,0,20.4c0,2.7,2.2,4.9,4.9,4.9H21h0 c0.3,0,0.7,0,1-0.1C24.7,24.6,26.4,22,25.9,19.4z M10.8,3.5c0.6-0.7,1.5-1,2.4-0.9c1.1,0.1,2,0.7,2.6,1.7c0.6,0.9,1,1.9,1.2,3H9 C9.4,5.6,10,4.3,10.8,3.5z M21,23.4H4.9c-0.2,0-0.4,0-0.6-0.1c-1.7-0.3-2.7-2-2.4-3.6l1.5-7.4c0.2-1,1.1-1.7,2.1-1.7l1.1,0 c0,0.5-0.1,1.1-0.1,1.6c-0.6,0.3-1.1,1-1.1,1.8c0,1.1,0.9,2,2,2c1.1,0,2-0.9,2-2c0-0.7-0.4-1.4-1-1.7c0-0.5,0.1-1.1,0.1-1.6l9,0 c0,0.5,0.1,1.1,0.1,1.6c-0.6,0.3-1,1-1,1.7c0,1.1,0.9,2,2,2s2-0.9,2-2c0-0.8-0.4-1.4-1.1-1.8c0-0.5,0-1.1-0.1-1.6l1.1,0 c1,0,1.9,0.7,2.1,1.7l1.5,7.4c0,0.2,0.1,0.4,0.1,0.6C24.1,22.1,22.7,23.4,21,23.4z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMalinha);
export default __webpack_public_path__ + "static/media/Malinha.a054d536f5ef880db913120a703766ea.svg";
export { ForwardRef as ReactComponent };